/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchBlockRegistrationDomainDataParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('block')],
    ['domain', /* #__PURE__ */ codecOptional(codecString)],
    [
        'matchSubdomains',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'match_subdomains',
    ],
]);
export class PatchBlockRegistrationDomainData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchBlockRegistrationDomainDataParser.decode(input).map(res => new PatchBlockRegistrationDomainData(res));
    }
    static unsafeDecode(input) {
        return PatchBlockRegistrationDomainData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchBlockRegistrationDomainDataParser.encode(data);
    }
    static schema() {
        return PatchBlockRegistrationDomainDataParser.schema();
    }
}
